
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokegetSkillProf, invokeAssignProxyToLearners } from '@/utils/admin/assign_proxy_service';
import { getAllProxyAssignedLearnersForProgram, invokeAssignedProxyTriggerReport } from '@/utils/admin/view_proxy_request_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import moment from 'moment';
import { invokegetAllProgram } from '@/utils/admin/task_management_service';
import axios, { AxiosError } from 'axios';
import { invokegetAllProxies } from '@/utils/admin/manage_proxy_service';
import { postApi } from '@/utils/ApiCalls';
import { getProgramDetails } from '@/utils/admin/program_services';
import SearchBar from '@/components/global/SearchBar.vue';

// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'ViewAllProgramProxyAssignment',
  components: { SearchBar },

  setup() {
    const learnerData = ref();
    const skills = ref();
    const proficiency = ref();
    const renderReady = ref();
    const selectedSkill = ref();
    const selectedProficiency = ref();
    const isVisible = ref(false);
    const proxyButtonVisible = ref(false);
    const proxyList = ref();
    const selectedTaskId = ref([]);
    const selectedProxyOhr = ref();
    const proxyAssignedBtn = ref(false);
    const userRole = ref();
    const showScreen = ref(true);
    const selectedLearnerSkill = ref();
    const selectedLearnerProficiency = ref();
    const reportSuccessMessage = ref();
    const programDetails = ref();
    const showSkillProf = ref(false);
    const selectedProgram = ref('Select Program');
    const showSearchBtn = ref(false);
    const resMessage = ref();
    const showSuccessMessage = ref(false);
    const showErrorMessage = ref(false);
    const errorMessage = ref();
    const nudgeButtonVisible = ref(false);
    const selectedAgeing = ref('Select Ageing');
    const enteredProxyOHR = ref();
    const enteredLearnerTaskId = ref();
    const selectedLowerBound = ref();
    const selectedUpperBound = ref();
    const noUpperBound = ref(false);
    const filteredLearnerData = ref();
    const proxyDetailsArray = ref();
    const filteredproxyDetails = ref();
    const ageingValues = ref(['0-5', '5-10', '10-15', '15-20', '>20']);
    const rangeStart = ref('');
    const rangeEnd = ref('');
    const skillErrorMessage = ref();
    const proficiencyError = ref();
    const defaultErrorMessage = ref();
    const checkOne = () => {
      selectedProxyOhr.value = [];
    };
    const performAgeingFilter = () => {
      console.log(selectedAgeing.value);
      // let selectedLowerBound;
      // let selectedUpperBound;
      // let noUpperBound = false;
      noUpperBound.value = false;
      if (selectedAgeing.value === 'Select Ageing') {
        filteredLearnerData.value = learnerData.value;
        selectedLowerBound.value = false;
        selectedUpperBound.value = false;
        return;
      }
      if (selectedAgeing.value.includes('>')) {
        selectedLowerBound.value = selectedAgeing.value.slice(1);
        noUpperBound.value = true;
        selectedUpperBound.value = true;
      } else {
        [selectedLowerBound.value, selectedUpperBound.value] = selectedAgeing.value.split('-');
      }
      console.log(selectedLowerBound.value, selectedUpperBound.value);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, consistent-return, array-callback-return
      // filteredLearnerData.value = learnerData.value.filter((item: any) => {
      //   console.log(item.ageing, item.ageing >= min && (noUpperBound || item.ageing <= max));
      //   if (item.ageing >= min && (noUpperBound || item.ageing <= max)) {
      //     return item;
      //   }
      // });
    };

    const sendNudge = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const proxyOhrNudgeList: any[] = [];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, consistent-return, array-callback-return
      filteredLearnerData.value.filter((item) => {
        for (let i = 0; i < selectedTaskId.value.length; i += 1) {
          if (selectedTaskId.value[i] === item.learner_task_id) {
            proxyOhrNudgeList.push({
              learner_task_id: item.learner_task_id,
              proxyOhr: item.proxy_key,
            });
          }
        }
      });
      const payload = { nudge_arr: proxyOhrNudgeList };
      console.log(' Proxy OHR ', payload);

      try {
        renderReady.value = false;
        const res = await postApi('/proxyreview/nudge', payload);
        console.log(res);
        resMessage.value = res.data.message;
        renderReady.value = true;
        showSuccessMessage.value = true;
        showErrorMessage.value = false;
        window.scroll(0, 0);
        renderReady.value = true;
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 5000);
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          showErrorMessage.value = true;
          showSuccessMessage.value = false;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 5000);
        }
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setProxyBtn = (event: any) => {
      // selectedTaskId.value = [];
      const cb = event.target.checked;
      // if (cb === true) {
      //   proxyButtonVisible.value = true;
      //   // console.log(cb);
      // } else {
      //   proxyButtonVisible.value = false;
      //   isVisible.value = false;
      // }
      if (cb === true) {
        console.log('selected Task id', selectedTaskId.value);
        proxyButtonVisible.value = true;
        // console.log(cb);
      } else if (selectedTaskId.value.length === 0) {
        proxyButtonVisible.value = false;
        isVisible.value = false;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const FilterData: any = {};
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      // console.log(programDetails.value);
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProgram = async (e: any) => {
      renderReady.value = false;
      localStorage.setItem('program', e.target.value);

      localStorage.removeItem('skill');
      localStorage.removeItem('proficiency');
      selectedProgram.value = e.target.value;
      // Object.assign(FilterData, { skill: selectedProgram.value });
      if (selectedProgram.value !== 'Select Program') {
        showSearchBtn.value = true;
        if (selectedProgram.value === 'infinity') {
          await getSkillandProf();
          selectedSkill.value = 'Select Skill';
          selectedProficiency.value = 'Select Proficiency';
          showSkillProf.value = true;
          // showSequencBtn.value = false;
        } else {
          showSkillProf.value = false;
          selectedSkill.value = '';
          selectedProficiency.value = '';
        }
        // localStorage.setItem('inputValue', selectedProgram.value);
        // await getTaskDetails();
      } else {
        showSearchBtn.value = false;
        showSkillProf.value = false;
      }
      proxyButtonVisible.value = false;
      nudgeButtonVisible.value = false;
      learnerData.value = [];
      isVisible.value = false;
      selectedTaskId.value = [];
      filteredLearnerData.value = [];
      renderReady.value = true;
      // localStorage.setItem('program', selectedProgram.value);
      // localStorage.removeItem('inputValue');
    };
    const getLearnerForProxy = async () => {
      try {
        // if (FilterData.skill && FilterData.proficiency) {
        // selectedProgram.value === 'Select Program' ? (selectedProgram.value = '') : null;
        if (selectedProgram.value === 'Select Program') {
          // selectedProgram.value = '';
          if (!enteredLearnerTaskId.value) {
            defaultErrorMessage.value = 'Please Select Program or Enter Learner Task ID';
            setTimeout(() => {
              defaultErrorMessage.value = null;
            }, 6000);
            return;
          }
        }
        if (selectedProgram.value === 'infinity') {
          if (selectedSkill.value === 'Select Skill') {
            skillErrorMessage.value = 'Please Select Skill';
            setTimeout(() => {
              skillErrorMessage.value = null;
            }, 6000);
            return;
          }
          if (selectedProficiency.value === 'Select Proficiency') {
            proficiencyError.value = 'Please Select Proficiency';
            setTimeout(() => {
              proficiencyError.value = null;
            }, 6000);
            return;
          }
        }
        const data = {
          linked_program_name: selectedProgram.value,
          skill: selectedSkill.value,
          proficiency: selectedProficiency.value,
          proxy_key: enteredProxyOHR.value,
          learner_task_id: enteredLearnerTaskId.value,
          selectedLowerBound: selectedLowerBound.value,
          selectedUpperBound: selectedUpperBound.value,
          noUpperBound: noUpperBound.value,
        };
        console.log({ data });
        renderReady.value = false;
        await checkOne();
        selectedTaskId.value = [];
        proxyButtonVisible.value = false;
        isVisible.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataRes: any = await getAllProxyAssignedLearnersForProgram(data);
        learnerData.value = dataRes.data.allProxyList;
        console.log(' learnerData.value', learnerData.value);
        await getSkillandProf();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // learnerData.value = learnerData.value.sort((a: any, b: any) => moment(a.assignment_date).utc().unix() - moment(b.assignment_date).utc().unix());
        for (let index = 0; index < learnerData.value.length; index += 1) {
          const res = learnerData.value[index];
          console.log(`res ${JSON.stringify(res)}`);
          const today = moment().utc().format('YYYY-MM-DD');
          if (res.assignment_date) {
            const assignDateFormatted = moment(res.assignment_date).utc().format('YYYY-MM-DD');
            res.ageing = moment(today).diff(moment(assignDateFormatted), 'days');
            res.assignment_date = moment(res.assignment_date).format('DD-MM-YYYY');
          }
          if (res.proxy_requested_date) {
            res.proxy_requested_date = moment(res.proxy_requested_date).format('DD-MM-YYYY');
          }
          if (res.linked_program_name === 'infinity') {
            if (res.skill) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const learnerSkillArr = skills.value.filter((item: any) => {
                console.log(`item ${JSON.stringify(item)}`);
                const skill = item.skill_id;
                console.log(`skill ${skill}`);
                if (skill) {
                  return skill === res.skill;
                }
                return false;
              });
              console.log(`learnerSkillArr ${JSON.stringify(learnerSkillArr)}`);
              res.skillName = learnerSkillArr[0].skill_alias;
            } else {
              res.skillName = '';
            }
            if (res.proficiency) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const learnerProfArr = proficiency.value.filter((item: any) => {
                console.log(`item ${JSON.stringify(item)}`);
                const prof = item.prof_id;
                console.log(`prof ${prof}`);
                if (prof) {
                  return prof === res.proficiency;
                }
                return false;
              });
              console.log(`learnerProfArr ${JSON.stringify(learnerProfArr)}`);
              res.proficiencyName = learnerProfArr[0].prof_name;
            } else {
              res.proficiencyName = '';
            }
          }
        }
        // if (selectedProgram.value === 'Select Program' && enteredLearnerTaskId.value.length > 0 && learnerData.value.length > 0) {
        if (learnerData.value.length > 0 && learnerData.value[0].linked_program_name === 'infinity') {
          selectedSkill.value = learnerData.value[0].skill;
          selectedProficiency.value = learnerData.value[0].proficiency;
          showSkillProf.value = true;
        } else {
          showSkillProf.value = false;
        }
        // }
        learnerData.value.length > 0 ? (selectedProgram.value = learnerData.value[0].linked_program_name) : null;
        const res = await getProgramDetails(selectedProgram.value);
        const eventType = 'PROXY_NUDGE';
        const events = res.prog_detail.email_templates;
        nudgeButtonVisible.value = events[eventType] !== undefined;
        filteredLearnerData.value = learnerData.value;
        // performAgeingFilter();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        learnerData.value = learnerData.value.sort((a: any, b: any) => b.ageing - a.ageing);
        // if (learnerData.value.length > 0) {
        //   learnerData.value.sort((a: any, b: any) => parseInt(b.ageing, 10) - parseInt(a.ageing, 10));
        // }
        // }
      } catch (error) {
        console.log(error);
      }
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      selectedSkill.value = e.target.value;
      console.log(`selectedSkill.value ${selectedSkill.value}`);
      // Object.assign(FilterData, { skill: selectedSkill.value });
      // await getLearnerForProxy();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      selectedProficiency.value = e.target.value;
      console.log(`selectedProficiency.value ${selectedProficiency.value}`);
      // Object.assign(FilterData, { proficiency: selectedProficiency.value });
      // await getLearnerForProxy();
    };
    const showProxy = async () => {
      console.log(`selectedTaskId.value[0] ${selectedTaskId.value[0]}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let url = `/v2/admin/proxy/program/${selectedProgram.value}`;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const selectedLearnerArr = learnerData.value.filter((learner: any) => selectedTaskId.value[0] === learner.learner_task_id);
      console.log(`selectedLearnerArr ${selectedLearnerArr}`);
      if (selectedProgram.value === 'infinity') {
        selectedLearnerSkill.value = selectedLearnerArr[0].skill;
        selectedLearnerProficiency.value = selectedLearnerArr[0].proficiency;
        url = `/v2/admin/proxy/program/infinity/skill/${selectedLearnerSkill.value}`;
      }

      isVisible.value = true;
      renderReady.value = false;
      // const data = {
      //   linked_program_name: selectedProgram.value,
      //   skill_id: selectedLearnerSkill.value,
      // };
      const res = await invokegetAllProxies(url);
      // const res = await invokeProgramProxies('/getAllProxyByProgram', data);
      proxyList.value = res.all_proxies;
      proxyDetailsArray.value = proxyList.value.map((proxy) => proxy.proxy_name);
      filteredproxyDetails.value = proxyList.value;
      renderReady.value = true;
      console.log('Proxy List', proxyList.value);
    };
    const getFilteredList = (value) => {
      // filteredProgramDetails.value = value;
      // console.log('ProgramDetails.value in final', ProgramDetails.value);
      filteredproxyDetails.value = proxyList.value.filter((proxy) => value.includes(proxy.proxy_name));
      console.log('filteredproxyDetails', filteredproxyDetails.value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showAssignProxyBtn = async (event: any) => {
      const proxyOhr = event.target.checked;
      if (proxyOhr === true) {
        proxyAssignedBtn.value = true;
      } else {
        proxyAssignedBtn.value = false;
      }
    };
    const assignLearnerToProxy = async () => {
      try {
        console.log(`selectedProxyOhr.value[0] ${selectedProxyOhr.value[0]}`);
        console.log(`selectedSkill.value ${selectedSkill.value}`);
        console.log(`selectedProficiency.value ${selectedProficiency.value}`);
        renderReady.value = false;
        const data = {
          proxy_key: selectedProxyOhr.value[0],
          learners: selectedTaskId.value,
          linked_program_name: selectedProgram.value,
          skill: selectedLearnerSkill.value,
          proficiency: selectedLearnerProficiency.value,
        };
        const assignProxyRes = await invokeAssignProxyToLearners('/proxyreview', data);
        resMessage.value = assignProxyRes?.data.message;
        showSuccessMessage.value = true;
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 6000);
        isVisible.value = false;
        await getLearnerForProxy();
        // router.push({ path: 'assignProxy' });
        // router.go(0);
        renderReady.value = true;
        console.log('data ohr', assignProxyRes);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log('err.response?.data', err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const triggerProxyReport = async () => {
      try {
        if (!rangeStart.value || !rangeEnd.value) {
          resMessage.value = 'Start Date or End Date should not be empty';
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
          return;
        }
        const data = {
          start_date: rangeStart.value,
          end_date: rangeEnd.value,
          program_id: selectedProgram.value,
          skill: selectedSkill.value,
          proficiency: selectedProficiency.value,
          proxy_ohr: enteredProxyOHR.value,
          learner_task_id: enteredLearnerTaskId.value,
        };
        const reportResponse = await invokeAssignedProxyTriggerReport(data);
        reportSuccessMessage.value = 'The report will be emailed to you';
        setTimeout(() => {
          reportSuccessMessage.value = null;
        }, 6000);
        console.log(`Report Trigger Response ${reportResponse}`);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log('err.response?.data', err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    onBeforeMount(async () => {
      await getProgram();
      // await getLearnerForProxy();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('Community Manager') || userRole.value.includes('Proxy Admin')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      learnerData,
      skills,
      proficiency,
      renderReady,
      selectedSkill,
      selectedProficiency,
      getSelectedSkill,
      getSelectedProficiency,
      isVisible,
      showProxy,
      getSkillandProf,
      getLearnerForProxy,
      selectedTaskId,
      proxyButtonVisible,
      setProxyBtn,
      proxyList,
      selectedProxyOhr,
      checkOne,
      showAssignProxyBtn,
      proxyAssignedBtn,
      assignLearnerToProxy,
      showScreen,
      triggerProxyReport,
      reportSuccessMessage,
      programDetails,
      getSelectedProgram,
      showSearchBtn,
      selectedProgram,
      showSkillProf,
      resMessage,
      showSuccessMessage,
      showErrorMessage,
      errorMessage,
      performAgeingFilter,
      ageingValues,
      filteredLearnerData,
      selectedAgeing,
      sendNudge,
      nudgeButtonVisible,
      getFilteredList,
      filteredproxyDetails,
      proxyDetailsArray,
      rangeStart,
      rangeEnd,
      enteredProxyOHR,
      enteredLearnerTaskId,
      skillErrorMessage,
      proficiencyError,
      defaultErrorMessage,
    };
  },
});
